import * as moment from 'moment';

import { TimeUnit, DayOfWeek } from '../../../models';
import { IAlignmentStrategy } from './IAlignmentStrategy';

export class YearAlignmentStrategy implements IAlignmentStrategy {
    align(
        input: moment.Moment,
        beginTime: moment.Duration,
        interval: number,
        intervalTimeUnit: TimeUnit,
        dayOfWeek: DayOfWeek
    ): moment.Moment {
        let result: moment.Moment = null;

        if (intervalTimeUnit === TimeUnit.Year) {
            let years = input.year();

            if (input.date() !== 1
                || input.month() !== 0
                || (input.date() === 1 && input.month() === 0 && input.hours() > beginTime.hours())
            ) {
                years += interval;
            }

            result = moment()
                .year(years)
                .startOf('y')
                .add(beginTime.asMinutes(), 'm');
        }

        return result;
    }
}